// src/PrivateRoute.js
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';


export default function PrivateRoute({children}) {
  const { currentUser } = useAuth();
  console.log('voici user', currentUser)
  if (!currentUser){
    return<Navigate to={"/"} replace />;
  }
  return children
}
